import _ from 'lodash';

export default {
    namespaced: true,
    state: () => ({
        category: null,
        statuses: [],
        counter: null,
    }),
    mutations: {
        SET_CATEGORY (state, payload){
            state.category = payload;
        },
        SET_STATUS (state, payload){
            let exists = state.statuses.find(x => x.category == state.category);

            if (exists) {
                exists.value = payload;
            } else {
                state.statuses.push({category: state.category, value: payload});
            }
        },
        SET_COUNTER (state, payload) {
            state.counter = payload;
        },
    },
    actions: {
        prepareDefaultCategoryFromFilterItems({ state, commit, rootGetters }, filterItems) {
            let permissions = rootGetters['global/auth/getUserInfo']?.Permissions ?? [];
            let items = filterItems.filter(i => _.difference(i.Requires, permissions).length === 0);

            if (!state.collection)
                commit('SET_CATEGORY', items?.[0]?.Value ?? 'unknown');
        }
    },
    getters: {
        getCategory: (s) => s.category,
        getStatus: (s) => {
            const exists = s.statuses.find(x => x.category == s.category);
            if (exists)
                return exists.value;
            else {
                return "-10";
            }
        },
        getCounter: (s) => s.counter,
    }
}